import { render, staticRenderFns } from "./PrescriptionForm.vue?vue&type=template&id=67b041de&scoped=true"
import script from "./PrescriptionForm.vue?vue&type=script&lang=ts"
export * from "./PrescriptionForm.vue?vue&type=script&lang=ts"
import style0 from "./PrescriptionForm.vue?vue&type=style&index=0&id=67b041de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b041de",
  null
  
)

export default component.exports